export default "<form #f=\"ngForm\">\n  <app-delivery-times-calculator></app-delivery-times-calculator>\n</form>\n"